"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromNano = exports.toNano = void 0;
const ethUnit = require('ethjs-unit');
function toNano(src) {
    return ethUnit.toWei(src, 'gwei');
}
exports.toNano = toNano;
function fromNano(src) {
    return ethUnit.fromWei(src, 'gwei');
}
exports.fromNano = fromNano;
